import {Routes, RouterModule}                        from '@angular/router';
import {LoginComponent}                              from './login/login.component';
import {HomeComponent}                               from './home/home.component';
import {AuthenticationService}                       from './shared/authentication.service';
import {AddMessageComponent}                         from './messages/add.component';
import {ImportMessageComponent}                      from './messages/import.component';
import {CheckMessageComponent}                       from './messages/check.component';
import {EditMessageComponent}                        from './messages/edit.component';
import {MessageOverviewComponent}                    from './messages/overview.component';
import {LanguagesGroupedResolver, LanguagesResolver} from './shared/languages.resolver';
import {Permission}                                  from './shared/api/permissions/api.models';
import {CanDo}                                       from './shared/CanDo';
import {MessagecentralsResolver}                     from './shared/resolvers/messagecentrals.resolver';

const routes: Routes = [
    {
        path: '',
        pathMatch : 'full',
        redirectTo: '/login'
    },
    {
        path : 'login',
        component : LoginComponent
    },
    {
        path : 'home',
        component: HomeComponent,
        canActivate : [AuthenticationService]
    },
    {
        path: 'messages/overview',
        component : MessageOverviewComponent,
        resolve : {
            languages: LanguagesGroupedResolver
        },
        canActivate: [AuthenticationService, CanDo],
        data : {
            canDo : [
                Permission.MESSAGES_SHOW_OVERVIEW
            ]
        }
    },
    {
        path : 'messages/add',
        component : AddMessageComponent,
        resolve: {
            languages: LanguagesGroupedResolver
        },
        canActivate: [AuthenticationService, CanDo],
        data : {
            canDo : [
                Permission.MESSAGES_WRITE_NEW_MESSAGES
            ]
        }
    },
    {
        path : 'messages/edit',
        component : EditMessageComponent,
        resolve: {
            languages: LanguagesGroupedResolver
        },
        canActivate: [AuthenticationService, CanDo],
        data : {
            canDo : [
                Permission.MESSAGES_EDIT_MESSAGES
            ]
        }
    },
    {
        path : 'messages/import',
        component : ImportMessageComponent,
        resolve: {
            messagecentrals: MessagecentralsResolver,
            languages: LanguagesResolver
        },
        canActivate : [AuthenticationService],
        data: {
            canDo : [
                Permission.MESSAGES_IMPORT_POKES
            ]
        }
    },
    {
        path : 'messages/check',
        component : CheckMessageComponent,
        resolve: {
            languages: LanguagesGroupedResolver
        },
        canActivate : [AuthenticationService, CanDo],
        data : {
            canDo : [
                Permission.MESSAGES_CHECK_MESSAGES
            ]
        }
    },
    {
        path : '**',
        component: LoginComponent
    }
];

export const routing = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/app.routing.ts